import { ReactNodeViewRenderer, Node, mergeAttributes } from '@tiptap/react'
import { Component } from './component'

declare module '@tiptap/core' {
	interface Commands<ReturnType> {
		numberInput: {
			setNumberInput: () => ReturnType
			setNumberInputRequired: (value: boolean) => ReturnType
			setNumberInputTo: (value: string) => ReturnType
		}
	}
}

export const NumberInput = Node.create({
	name: 'numberInput',

	content: 'block*',

	defining: true,

	group: 'block',

	addAttributes() {
		return {
			name: {
				default: 'data_someData',
			},
			placeholder: {
				default: 'Type something...',
			},
			required: {
				default: false,
			},
			to: {
				default: 'none',
			},
		}
	},

	parseHTML() {
		return [
			{
				tag: 'numberInput',
			},
		]
	},

	renderHTML({ HTMLAttributes }) {
		return ['numberInput', mergeAttributes(HTMLAttributes), 0]
	},

	addCommands() {
		return {
			setNumberInput:
				() =>
				({ commands }) =>
					commands.insertContent({
						type: 'numberInput',
					}),
			setNumberInputRequired:
				(value: boolean) =>
				({ commands }) =>
					commands.updateAttributes('numberInput', {
						required: value,
					}),
			setNumberInputTo:
				(value: string) =>
				({ commands }) =>
					commands.updateAttributes('numberInput', {
						to: value,
					}),
		}
	},

	addNodeView() {
		return ReactNodeViewRenderer(Component)
	},
})

export default NumberInput
